export default __webpack_public_path__ + "static/media/securite.369d9209.svg";